function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#457446;}.cls-2{fill:none;stroke:#457446;stroke-miterlimit:10;stroke-width:4px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pecil"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.76,34.6a1,1,0,0,1-1-1,.49.49,0,0,1,0-.12l.77-7a1,1,0,0,1,.29-.59L28.18,9.54a3.19,3.19,0,0,1,4.52,0h0l3.11,3.11a3.2,3.2,0,0,1,0,4.53h0L19.47,33.53a1,1,0,0,1-.59.29l-7,.77Zm7-1.78Zm-5.27-5.77-.6,5.42,5.42-.6,16.1-16.1a1.2,1.2,0,0,0,0-1.7h0L31.29,11a1.2,1.2,0,0,0-1.7,0h0Z",
  transform: "translate(-1.75 -1.6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.76,19.81a1,1,0,0,1-.71-.29l-6.21-6.23a1,1,0,1,1,1.42-1.42l6.23,6.23a1,1,0,0,1,0,1.42h0A1,1,0,0,1,32.76,19.81Z",
  transform: "translate(-1.75 -1.6)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 17.15,
  y: 21.71,
  width: 11.01,
  height: 2,
  transform: "translate(-11.17 21.07) rotate(-45)"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "cls-2",
  cx: 21,
  cy: 21,
  r: 19
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_1",
    "data-name": "Edit 1",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Edit.3042810f.svg";
export { ForwardRef as ReactComponent };